import './focus_navigation';

$(function () {
    var $mapLinks = $('.map__link');
    var $languageModal = $('#languageModal');

    // map
    function toggleInfo(event) {
        var $mapLink = $(this);
        var state = $(this).children(0).get(0).id;
        var $info = $('#' + state + '-text');

        // turn off all other states
        if (['mouseenter', 'focus'].indexOf(event.type) > -1) {
            $info.addClass('in');
            $info.attr('aria-hidden', 'false');
            $mapLink.attr('aria-expanded', 'true');
        }

        if (['mouseleave', 'blur'].indexOf(event.type) > -1) {
            $info.removeClass('in');
            $info.attr('aria-hidden', 'true');
            $mapLink.attr('aria-expanded', 'false');
        }
    }

    $mapLinks.mouseleave(toggleInfo);
    $mapLinks.mouseenter(toggleInfo);
    $mapLinks.focus(toggleInfo);
    $mapLinks.blur(toggleInfo);
});

var modal = document.querySelector('.modal')

window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        //modal.style.display = 'none'
        $('.modal:not(.cookie-consent, .cookie-setting)').modal('hide');
    }
})

/*
document.addEventListener('DOMContentLoaded', function () {
    const teaser = document.querySelector('.teaser');
    const checkbox = teaser.querySelector('.form-check-input');
    const select = teaser.querySelector('.form-select');
    const button = teaser.querySelector('.btn--primary');

    if (!checkbox || !select || !button) return;

    function updateButtonState() {
        button.disabled = !(checkbox.checked && select.value !== '');
    }

    // Initialen Zustand setzen
    updateButtonState();

    checkbox.addEventListener('change', updateButtonState);
    select.addEventListener('change', updateButtonState);
});
 */



//////////////////
// WEBPACK FOOTER
// ./src/js/app.js
// module id = 0
// module chunks = 0